<script setup lang="ts">
import {
  COMPANY_TELEGRAM_LINK,
  COMPANY_FACEBOOK_LINK,
  COMPANY_INSTAGRAM_LINK,
} from '@/shared/constants/contacts';

import TelegramLogo from '@/shared/ui/Icons/TelegramLogo.vue';
import FacebookLogo from '@/shared/ui/Icons/FacebookLogo.vue';
import InstagramLogo from '@/shared/ui/Icons/InstagramLogo.vue';
import TelegramSupportButton from '@/widgets/telegramSupportButton/index';

const { t } = useI18n();
</script>

<template>
  <div class="footer-social">
    <div class="footer-social__item _support">
      <TelegramSupportButton />
      <time class="footer-social__time">{{ t('workingHours') }}</time>
    </div>
    <div class="footer-social__item _social">
      <a
        :href="COMPANY_TELEGRAM_LINK"
        class="footer-social__link"
        target="_blank"
        aria-label="Telegram"
      >
        <TelegramLogo class="footer-social__icon" />
      </a>
      <a
        :href="COMPANY_FACEBOOK_LINK"
        class="footer-social__link"
        target="_blank"
        aria-label="Facebook"
      >
        <FacebookLogo class="footer-social__icon" />
      </a>
      <a
        :href="COMPANY_INSTAGRAM_LINK"
        class="footer-social__link"
        target="_blank"
        aria-label="Instagram"
      >
        <InstagramLogo class="footer-social__icon" />
      </a>
    </div>
  </div>
</template>

<style lang="less">
.footer-social {
  .flex-column(54px);

  &__item {
    &._support {
      .flex-column(@size-x2);
    }

    &._social {
      display: inline-flex;
      gap: 10px;
    }
  }

  &__time {
    font-size: 14px;
    line-height: 100%;
    font-weight: 500;
    color: @color-silver-chalice;
  }

  &__link {
    display: flex;
    justify-content: center;
    width: 44px;
    height: 44px;
    background-color: #fff;
    border-radius: @size-x3;
    padding: @size-x2;
  }

  &__icon {
    width: @size-x7;
    height: @size-x7;
  }
}
</style>
